import { useMemo, useState } from "react";
import Container from "../common/Container";
import SectionTitle from "../common/SectionTitle";
import Button from "../common/Button";
import { pricingTabs } from "../../data/siteData";
import { FaCheckCircle } from "react-icons/fa";
import "../../styles/Pricing.css";

export default function Pricing() {
  const [tab, setTab] = useState(pricingTabs[0].key);

  const active = useMemo(
    () => pricingTabs.find((t) => t.key === tab) || pricingTabs[0],
    [tab]
  );

  return (
    <section id="pricing" className="pricing-section">
      {/* Background elements for depth */}
      <div className="pricing-grid-bg"></div>
      <div className="pricing-floating-circle"></div>

      <Container>
        <div className="pricing-header-wrapper">
          <SectionTitle
            badge="Our Pricing"
            title="Professional Packages"
            desc="Transparent pricing models tailored for Australian homes and businesses."
          />
        </div>

        <div className="pricing-container">
          {/* Tab Selection */}
          <div className="tab-navigation">
            {pricingTabs.map((t) => (
              <button
                key={t.key}
                className={`tab-btn ${t.key === tab ? "active" : ""}`}
                onClick={() => setTab(t.key)}
              >
                {t.label}
              </button>
            ))}
          </div>

          {/* Pricing Card Content */}
          <div className="pricing-main-card">
            <div className="package-info">
              <h3>{active.label} Service Scope</h3>
              <p className="package-subtitle">Our standard inclusions for {active.label.toLowerCase()} maintenance:</p>
              
              <div className="points-grid">
                {active.points.map((p, idx) => (
                  <div key={idx} className="point-item">
                    <FaCheckCircle className="point-icon" />
                    <span>{p}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="quote-cta-box">
              <div className="cta-inner">
                <h4>Custom Quote</h4>
                <p>
                  Every property is unique. For a precise estimate based on your specific square meterage and requirements:
                </p>
                <div className="price-placeholder">Request Estimate</div>
                <Button as="a" href="#contact" variant="primary" className="btn-full-width">
                  Contact Us Now
                </Button>
                <p className="cta-note">*Response within 2 hours</p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}